(function(){
  'use strict';

  // Autoplay (muet) des qu'une partie de la video est visible : la video qui depasse sur mobile tourne aussi
  function initUGC(){
    var cards = document.querySelectorAll('[data-nuvy-ugc-card]');
    if (!cards.length) return;

    function tryPlay(video){
      var p = video.play();
      if (p !== undefined) p.catch(function(){ /* autoplay bloque : la miniature reste affichee */ });
    }

    if ('IntersectionObserver' in window){
      var observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          var video = entry.target.querySelector('[data-nuvy-ugc-video]');
          if (!video) return;
          if (entry.isIntersecting && entry.intersectionRatio > 0.15){
            tryPlay(video);
          } else {
            video.pause();
          }
        });
      }, { threshold: [0, 0.15, 0.5, 1] });
      cards.forEach(function(card){ observer.observe(card); });
    } else {
      document.querySelectorAll('[data-nuvy-ugc-video]').forEach(tryPlay);
    }

    // Bouton son : toggle mute
    document.querySelectorAll('[data-nuvy-ugc-sound]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.stopPropagation();
        var card = btn.closest('[data-nuvy-ugc-card]');
        if (!card) return;
        var video = card.querySelector('[data-nuvy-ugc-video]');
        if (!video) return;

        document.querySelectorAll('[data-nuvy-ugc-video]').forEach(function(v){
          if (v !== video){
            v.muted = true;
            var otherBtn = v.closest('[data-nuvy-ugc-card]').querySelector('[data-nuvy-ugc-sound]');
            if (otherBtn){
              otherBtn.querySelector('.nuvy-ugc__sound-icon--mute').style.display = '';
              otherBtn.querySelector('.nuvy-ugc__sound-icon--on').style.display = 'none';
              otherBtn.setAttribute('aria-label', 'Activer le son');
            }
          }
        });

        video.muted = !video.muted;
        if (video.paused) tryPlay(video);
        var muteIcon = btn.querySelector('.nuvy-ugc__sound-icon--mute');
        var onIcon = btn.querySelector('.nuvy-ugc__sound-icon--on');
        if (video.muted){
          muteIcon.style.display = '';
          onIcon.style.display = 'none';
          btn.setAttribute('aria-label', 'Activer le son');
        } else {
          muteIcon.style.display = 'none';
          onIcon.style.display = '';
          btn.setAttribute('aria-label', 'Couper le son');
        }
      });
    });

    // Clic sur la video : play/pause
    document.querySelectorAll('[data-nuvy-ugc-video]').forEach(function(video){
      video.addEventListener('click', function(){
        if (video.paused){ tryPlay(video); } else { video.pause(); }
      });
    });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initUGC);
  } else {
    initUGC();
  }
})();
